<template>
    <div class="flex justify-between">
      <h1 class=" ">{{ $t('message.linkUser.titleSection') }}</h1>
      <div>
        <zt-badge 
          class="chip"
          :color=" step > linkUserDataFormArray.length ? '379579' : 'primary' " 
        >
          <template v-if="step > 0 && step <= linkUserDataFormArray.length">
            <p>{{step}}&nbsp;</p> de {{ linkUserDataFormArray.length }} cuenta(s)
          </template>
          <template v-else-if="step === 0">
            {{ linkUserDataFormArray.length }} cuenta(s)
          </template>
          <template v-else>
            <p>{{linkUserDataFormArray.length}}&nbsp;</p> de {{ linkUserDataFormArray.length }} cuenta(s)
          </template>
        </zt-badge>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TitleLinkUser', //el chip tiene que ser ams cuadrado 
    props: ['step', 'linkUserDataFormArray']
  }
  </script>
  
  <style scoped>
    h1 {
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 28px;
      color: #2d2d2d;
    }
    .chip {
    display: flex;
    height: 24px;
    padding: 3px 10px;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: 4px;
    }
  </style>